import React from 'react'
import { Link } from 'react-router-dom';
import PageBanner from '../../../../common/components/PageBanner';
import banner from '../../../../assets/new-images/tribe_option_B_neighbourhood-together.png';
import "../styles/knowledge.css"

// TODO(refresh): MYREDFOLDER, Inc. to confirm which Tribe benefits exist today.
// Discounts, giveaways, webinars, alerts and community features were removed
// until they are confirmed; add back only what is live.
export default function MRFTribe() {
  return (
    <div>
      <PageBanner
        image={banner}
        alt="Neighbors of all ages gathered and talking on a street lit with string lights at dusk."
        eyebrow="Knowledge Base / Tribe"
        title="MYREDFOLDER® Tribe"
      />
      <section className="mrf-section">
        <div className="mrf-container" style={{ maxWidth: 880 }}>
          <p className="mrf-callout">
            Join the MYREDFOLDER® preparedness community for practical articles and updates. The newsletter is free;
            Premium membership is separate.
          </p>
          <div className="mrf-hero__actions">
            <Link className="mrf-btn mrf-btn--primary" to="/knowledgeBase/newsletter">Sign up for the free newsletter</Link>
            <Link className="mrf-btn mrf-btn--secondary" to="/knowledgeBase/blog">Read the blog</Link>
          </div>
        </div>
      </section>
    </div>
  )
}
